import { Box, Button, Paper, Text } from '@mantine/core';
import { UI } from '../../theme/kioskTheme';

const TECLAS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0', '←'];

// Teclado grande para tipear el número de la caravana. Se opera de pie y con
// el dedo, así que las teclas son de 64 px y no hay campo de texto: en una
// tablet en modo kiosco el teclado del sistema tapa media pantalla.
export function TecladoNumerico({ value, onChange, maxLen = 3 }) {
  const tecla = (k) => {
    if (k === 'C') return onChange('');
    if (k === '←') return onChange(value.slice(0, -1));
    if (value.length >= maxLen) return undefined;
    return onChange(value + k);
  };

  return (
    <Box>
      <Paper withBorder radius="md" p="xs" mb="xs"
             style={{ borderWidth: 2, borderColor: UI.borde }}>
        <Text ta="center" fw={900} ff="monospace"
              style={{ fontSize: 56, letterSpacing: 8, minHeight: 64, color: UI.tinta }}>
          {value || '···'}
        </Text>
      </Paper>

      <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {TECLAS.map(k => (
          <Button
            key={k}
            variant={/[0-9]/.test(k) ? 'outline' : 'light'}
            h={64}
            onClick={() => tecla(k)}
            styles={{ root: { fontSize: 26 } }}
          >
            {k}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
